var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-dialog',[_c('div',{staticClass:"dialog-wrapper dialog-readtip-wrapper"},[_c('div',{staticClass:"no-box"},[_c('img',{attrs:{"src":require('@/assets/imgs/answer/error.png')}}),_c('p',[_vm._v("仔细在游戏介绍中找到答案再试一次吧")])]),_c('button',{staticClass:"dialog-btn-submit",on:{"click":_vm.onClose}},[_vm._v("我知道了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }